import { useParams } from "react-router-dom";

import { Layout } from "Layout";

import { ListPage } from "components/ListPage/ListPage";

import { i18n } from "services/i18nService";

import { useEditModal } from "hooks/useEditModal";
import { usePlans } from "hooks/usePlans";
import { usePrivileges } from "hooks/usePrivileges";

import { Forbidden } from "Forbidden";
import { OBJECT_TYPES, USER_PRIVILEGE } from "appConstants";

const objectType = OBJECT_TYPES.RENTAL_RETURN.fullString;

export function RentalReturnList() {
  const { id } = useParams();

  const { hasPrivilegesOrIsAdmin } = usePrivileges();
  const { hasAtLeastPlusPlan } = usePlans();

  const hasPrivileges = hasPrivilegesOrIsAdmin([
    USER_PRIVILEGE.viewRentals,
    USER_PRIVILEGE.editRentals,
  ]);

  const allowList = hasPrivileges && hasAtLeastPlusPlan;
  useEditModal(objectType, id, allowList);

  return (
    <Layout pageTitle={i18n(`objectType.${objectType}.SentencePlural`)}>
      {allowList ? <ListPage objectType={objectType} /> : <Forbidden />}
    </Layout>
  );
}
